import Swiper from 'swiper';
import { Pagination, Navigation, Scrollbar } from 'swiper';

const setHandingSlider = () => {
  const targetSliders = document.querySelectorAll(".js-handing-slider");

  targetSliders.forEach(handingSlider => {
    const targetBlock = handingSlider.closest('.handing-slider-wrapper')

    var swiper = new Swiper(handingSlider, {
      modules: [Pagination, Navigation, Scrollbar],
      speed: 500,
      loop: true,
      slidesPerView: 'auto',

      pagination: {
        el: targetBlock.querySelector('.swiper-pagination'),
        clickable: true,
        type: 'bullets',
      },
    });
  })
}

export default setHandingSlider;